export const TRANSITION_IMAGE_DELAY = 100;
export const TRANSITION_LINES_DELAY = 180;
